/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const serviceQualityContractualDeviationEnumsIncidentAffectsACustomerOptionEnum = {
    Yes: 'Yes',
    No: 'No',
    CannotSpecify: 'CannotSpecify',
} as const;

export type ServiceQualityContractualDeviationEnumsIncidentAffectsACustomerOptionEnumKey =
    (typeof serviceQualityContractualDeviationEnumsIncidentAffectsACustomerOptionEnum)[keyof typeof serviceQualityContractualDeviationEnumsIncidentAffectsACustomerOptionEnum];

export type ServiceQualityContractualDeviationEnumsIncidentAffectsACustomerOption =
    ServiceQualityContractualDeviationEnumsIncidentAffectsACustomerOptionEnumKey;
